import script from "./wInbound.vue?vue&type=script&setup=true&lang=ts"
export * from "./wInbound.vue?vue&type=script&setup=true&lang=ts"

import "./wInbound.vue?vue&type=style&index=0&id=f7f7500a&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7f7500a"]])

export default __exports__